module.exports = __webpack_public_path__ + "fonts/Onest-VariableFont_wght.f0c8780.ttf";